﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX} from "react";
import {MvvmTextControlProps} from "./MvvmControlProps";
import MvvmInput from "./MvvmInput";

const numberToString = (value: number | undefined): string => value == null || isNaN(value) ? "" : value.toString();
const numberFromString = (value: string | undefined): number | undefined => isNullOrEmpty(value) ? undefined : parseFloat(value);

export interface MvvmNumberInputProps<T extends object = never> extends MvvmTextControlProps<T, number> {
	max?: number;
	min?: number;
	step?: number;
}

export default function MvvmNumberInput<T extends object = never>(props: MvvmNumberInputProps<T>): JSX.Element {
	return <MvvmInput<T, number> control={props}
	                             type={"number"}
	                             updateOnChange={true}
	                             max={props.max}
	                             min={props.min}
	                             step={props.step}
	                             valueToString={numberToString}
	                             valueFromString={numberFromString}/>;
}
